var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.43011 2.22461C5.66834 2.22461 6.67212 5.21199 6.67212 8.89711H4.43011C3.34962 8.89711 2.80938 8.89711 2.47495 8.52406C2.14053 8.151 2.19875 7.65973 2.31518 6.67718C2.62256 4.08338 3.4534 2.22461 4.43011 2.22461Z",
    stroke: "#2E1834",
    strokeWidth: 1.66812
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67212 8.95745V20.7361C6.67212 22.4172 6.67212 23.2578 7.18585 23.5887C8.02539 24.1294 9.32327 22.9955 9.97598 22.5838C10.5153 22.2437 10.785 22.0736 11.0843 22.0638C11.4077 22.0532 11.6821 22.2163 12.2649 22.5838L14.39 23.924C14.9632 24.2855 15.2499 24.4663 15.5688 24.4663C15.8877 24.4663 16.1744 24.2855 16.7476 23.924L18.8726 22.5838C19.412 22.2437 19.6817 22.0736 19.9809 22.0638C20.3044 22.0532 20.5788 22.2163 21.1616 22.5838C21.8143 22.9955 23.1122 24.1294 23.9517 23.5887C24.4655 23.2578 24.4655 22.4172 24.4655 20.7361V8.95745C24.4655 5.78356 24.4655 4.19661 23.4883 3.21061C22.5111 2.22461 20.9384 2.22461 17.793 2.22461H4.44796",
    stroke: "#2E1834",
    strokeWidth: 1.66812,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5688 8.89724C14.3404 8.89724 13.3446 9.64408 13.3446 10.5654C13.3446 11.4866 14.3404 12.2335 15.5688 12.2335C16.7971 12.2335 17.7929 12.9803 17.7929 13.9016C17.7929 14.8229 16.7971 15.5697 15.5688 15.5697M15.5688 8.89724C16.5372 8.89724 17.361 9.36143 17.6664 10.0093M15.5688 8.89724V7.78516M15.5688 15.5697C14.6004 15.5697 13.7765 15.1056 13.4712 14.4577M15.5688 15.5697V16.6818",
    stroke: "#2E1834",
    strokeWidth: 1.66812,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.f48dd0912e5d6b607af62b10fa8c419c.svg";
export { ForwardRef as ReactComponent };